import { render, staticRenderFns } from "./EditNivel3.vue?vue&type=template&id=cd0c7fdc&"
import script from "./EditNivel3.vue?vue&type=script&lang=js&"
export * from "./EditNivel3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports